import { createContext } from "react";
import { IContext } from "./auto-table-provider.types";

export const defaultContext: IContext<any> = { getRowKey: (row) => row.id };
export const AutoTableContext = createContext<IContext<any> | undefined>(defaultContext);
